// extracted by mini-css-extract-plugin
export default {"teamsInput":"styles_teamsInput__x0IvH"};